<template>
	<o-dropdown appendToBody aria-role="list" :disabled="exporting" v-if="!hide">
		<template v-slot:trigger>
			<slot v-if="!exporting">
				<o-button icon-left="share-alt">Share &amp; Save</o-button>
			</slot>
			<slot name="loading" v-else>
				<o-button class="magenta" icon-left="share-alt">
					<div style="display: flex">
						<div>Your report is being generated</div>
						<div style="width: 10px">{{ dots }}</div>
					</div>
				</o-button>
			</slot>
		</template>
		<o-dropdown-item aria-role="listitem" v-if="excel" @click="TriggerExcel">
			Download excel
		</o-dropdown-item>
		<o-dropdown-item aria-role="listitem" @click="TriggerCopy">Copy report link</o-dropdown-item>
	</o-dropdown>
</template>
<script>
	import { ref, inject, onBeforeUnmount, onBeforeMount } from "vue";
	export default {
		props: {
			report: {
				type: Object,
				default: () => {
					return null;
				}
			},
			hide: {
				type: Boolean,
				default: false
			},
			excel: {
				type: Boolean,
				default: false
			},
			exporting: {
				type: Boolean,
				default: false
			}
		},
		emits: ["shared", "excel"],
		setup(props, context) {
			const $error = inject("$error");
			const $success = inject("$success");
			const $pdf = inject("$pdf");
			const $http = inject("$http");

			let poll = null;
			const dots = ref("...");

			const TriggerCopy = async () => {
				// if (!props.report.Id && (props.report.results || [])?.length > 0) { //TODO: add 'hasRan' to the report object to use this
				// 	$error("Sharing is disabled for this report.");
				// 	return;
				// }

				if (props.report && props.report.Id) {
					try {
						const response = await $http.get("/api/v2/report/" + props.report.Id + "/stub");
						const stub = response.data;
						const uri = document.location.origin + "/report/" + stub;
						navigator.clipboard.writeText(uri);
						$success("Copied to clipboard");
						context.emit("shared", response.data);
					} catch (err) {
						console.error(err);
						$error("A problem occurred getting the stub.");
					}
				} else {
					$error("You must first run the report.");
				}
			};

			const TriggerExcel = () => {
				context.emit("excel");
			};

			onBeforeMount(() => {
				poll = setInterval(() => {
					const dotLength = (dots.value.length % 3) + 1;
					dots.value = ".".repeat(dotLength);
				}, 500);
			});

			onBeforeUnmount(() => {
				clearInterval(poll);
			});

			return {
				dots,
				TriggerCopy,
				TriggerExcel
			};
		}
	};
</script>
<style lang="scss" scoped>
	@use "@/assets/css/globalVars.scss" as *;

	.magenta {
		// background-color: $boyden-magenta;
		border-color: $boyden-magenta;
		color: $boyden-magenta;
		// &:hover {
		// 	background-color: inherit;
		// }
	}
</style>